import { chunk } from '@belong/common';
import { Carousel } from '@belong/ui';
import type { UnitListingModel } from 'src/api/models';
import { ListingUnitCard } from 'src/features/listing-page/components/listing-unit-card/listing-unit-card';
import { ListingsCarouselSlide } from './components/listing-carousel-slide/listing-carousel-slide';

type Props = {
  units: UnitListingModel[];
};

export function ListingsCarousel({ units }: Props) {
  const unitsWithoutRentAmount = units.map((unit) => ({
    ...unit,
    // Guarded because `ListingBasicInfoModel` requires an id and a unique id:
    // spreading an absent `listingInfo` produced neither.
    listingInfo: unit.listingInfo && {
      ...unit.listingInfo,
      rentAmount: undefined,
    },
  }));

  const mobileUnitSlides = chunk(unitsWithoutRentAmount, 1);
  const tabletUnitSlides = chunk(unitsWithoutRentAmount, 2);
  const desktopUnitSlides = chunk(unitsWithoutRentAmount, 3);

  const [onlyUnit] = unitsWithoutRentAmount;

  if (unitsWithoutRentAmount.length === 1 && onlyUnit) {
    return (
      <div className="gap-2xs container flex flex-col items-stretch md:items-start">
        <ListingUnitCard unit={onlyUnit} />
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <div className="contents md:hidden">
        <Carousel arrowsOnDots>
          <ListingsCarouselSlide unitSlide={mobileUnitSlides} />
        </Carousel>
      </div>
      {unitsWithoutRentAmount.length <= 3 ? (
        <div className="md:gap-lg hidden md:grid md:grid-cols-3">
          {unitsWithoutRentAmount.map((unitWithoutRentAmount) => (
            <ListingUnitCard
              key={unitWithoutRentAmount.basicInfo?.unitId}
              unit={unitWithoutRentAmount}
            />
          ))}
        </div>
      ) : (
        <>
          <div className="hidden md:contents xl:hidden">
            <Carousel arrowsOnDots>
              <ListingsCarouselSlide unitSlide={tabletUnitSlides} />
            </Carousel>
          </div>
          <div className="hidden xl:contents">
            <Carousel>
              <ListingsCarouselSlide unitSlide={desktopUnitSlides} />
            </Carousel>
          </div>
        </>
      )}
    </div>
  );
}
